import React from 'react';
import './DashboardHeader.scss';
import { UserMenu } from './UserMenu';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ERouterPath } from '../../features/router/ERouterPath';
import { ISessionAppState } from '../../app/session/reducer';

interface DashboardHeaderProps extends RouteComponentProps {
  title?: string;
  className?: string;
  session?: ISessionAppState;
}

function DashboardHeaderComponent(props: DashboardHeaderProps) {
  const { title, className, history } = props;
  const fullClassName = `dashboard-header-container ${className ? className : ''}`;

  return (
    <div className={fullClassName}>
      <header className="dashboard-header">
        <div className="dashboard-header__logo-center-box">
          <div className="dashboard-header__logo-container" onClick={() => history.push(ERouterPath.home)}>
            <div className="dashboard-header__logo" />
            <div className="dashboard-header__title ft-logo">
              MijnTOPP { title && <span className="dashboard-header__title-detail"> | {title}</span> }
            </div>
          </div>
        </div>
        <div className="dashboard-header__content">
          <div className="dashboard-header__user-menu">
            <UserMenu />
          </div>
        </div>
      </header>
    </div>
  );
}

export const DashboardHeader = withRouter(DashboardHeaderComponent);
